import {
    BankAccountSummaryDTO,
    CRCreditConditionSummaryDTO,
    CRInsuranceSummaryDTO,
    CRVehicleSummaryDTO,
    GpsSummaryDTO,
    MechanicalSummaryDTO,
} from '../../types/mx/epics';
import {
    GpsViewFieldErrorState,
    MechanicalWarrantyViewFieldErrorState,
    LoanApplicationMenuState,
    BankAccountInformationViewFieldErrorState,
    VehicleDataViewFieldErrorStateCR,
    CreditConditionViewFieldErrorStateCR,
    InsuranceViewFieldErrorStateCR
} from '../../types/mx/reducers';
import {Action} from '../../../../../common/types/common';
import {FieldSummary} from '../../../../types/mx/epics';
import {
    BankApplicationSummaryDTO, ClosingBankSummaryDTO,
    HomeSummaryDTO,
    PersonalSummaryDTO,
    ReferenceSummaryDTO,
    WorkSummaryDTO
} from '../../../common/types/epics';
import {
    ClosingBankViewFieldErrorState,
    HomeDataViewFieldErrorState,
    PersonalDataViewFieldErrorState, ReferenceViewFieldErrorState,
    WorkDataViewFieldErrorState
} from '../../../common/types/reducers';

export const ON_CHANGE_VMENU_ITEM: Action = {
    name: 'ON_CHANGE_VMENU_ITEM',
    action: item => ({
        item,
        type: ON_CHANGE_VMENU_ITEM.name
    })
};

export const ON_CHANGE_MAIN_SUBMENU_ITEM: Action = {
    name: 'ON_CHANGE_MAIN_SUBMENU_ITEM',
    action: (parentId: string, subItem: LoanApplicationMenuState) => ({
        parentId,
        subItem,
        type: ON_CHANGE_MAIN_SUBMENU_ITEM.name
    })
};

export const ON_CHANGE_MAIN_MENU_ITEM: Action = {
    name: 'ON_CHANGE_MAIN_MENU_ITEM',
    action: (item: LoanApplicationMenuState) => ({
        item,
        type: ON_CHANGE_MAIN_MENU_ITEM.name
    })
};

export const ON_MOUSE_ENTER_MAIN_MENU_ITEM: Action = {
    name: 'ON_MOUSE_ENTER_MAIN_MENU_ITEM',
    action: (item: LoanApplicationMenuState) => ({
        item,
        type: ON_MOUSE_ENTER_MAIN_MENU_ITEM.name
    })
};

export const ON_MOUSE_LEAVE_MAIN_MENU_ITEM: Action = {
    name: 'ON_MOUSE_LEAVE_MAIN_MENU_ITEM',
    action: (item: LoanApplicationMenuState) => ({
        item,
        type: ON_MOUSE_LEAVE_MAIN_MENU_ITEM.name
    })
};

export const ON_MOUSE_ENTER_MAIN_MENU: Action = {
    name: 'ON_MOUSE_ENTER_MAIN_MENU',
    action: () => ({
        type: ON_MOUSE_ENTER_MAIN_MENU.name,
    })
};

export const ON_MOUSE_LEAVE_MAIN_MENU: Action = {
    name: 'ON_MOUSE_LEAVE_MAIN_MENU',
    action: () => ({
        type: ON_MOUSE_LEAVE_MAIN_MENU.name,
    })
};

export const CHECK_PREVIEW_LOAN_APPLICATION_SUBMENU_ACTION: Action = {
    name: 'CHECK_PREVIEW_LOAN_APPLICATION_SUBMENU_ACTION',
    action: (personalDataFieldSummary: FieldSummary<PersonalSummaryDTO, PersonalDataViewFieldErrorState>,
             homeDataFieldSummary: FieldSummary<HomeSummaryDTO, HomeDataViewFieldErrorState>,
             workDataFieldSummary: FieldSummary<WorkSummaryDTO, WorkDataViewFieldErrorState>,
             referencesDataFieldSummary: FieldSummary<ReferenceSummaryDTO[], ReferenceViewFieldErrorState>,
             vehicleDataFieldSummary: FieldSummary<CRVehicleSummaryDTO, VehicleDataViewFieldErrorStateCR>,
             creditDataFieldSummary: FieldSummary<CRCreditConditionSummaryDTO, CreditConditionViewFieldErrorStateCR>,
             insuranceDataFieldSummary: FieldSummary<CRInsuranceSummaryDTO, InsuranceViewFieldErrorStateCR>) => ({
                 personalDataFieldSummary,
                 homeDataFieldSummary,
                 workDataFieldSummary,
                 referencesDataFieldSummary,
                 vehicleDataFieldSummary,
                 creditDataFieldSummary,
                 insuranceDataFieldSummary,
                 type: CHECK_PREVIEW_LOAN_APPLICATION_SUBMENU_ACTION.name,
             })
};

export const CHECK_PREVIEW_QUOTE_SUBMENU_ACTION: Action = {
    name: 'CHECK_PREVIEW_QUOTE_SUBMENU_ACTION',
    action: (personalDataFieldSummary: FieldSummary<PersonalSummaryDTO, PersonalDataViewFieldErrorState>,
             vehicleDataFieldSummary: FieldSummary<CRVehicleSummaryDTO, VehicleDataViewFieldErrorStateCR>,
             creditDataFieldSummary: FieldSummary<CRCreditConditionSummaryDTO, CreditConditionViewFieldErrorStateCR>,
             insuranceDataFieldSummary: FieldSummary<CRInsuranceSummaryDTO, InsuranceViewFieldErrorStateCR>,
             mechanicalFieldSummary: FieldSummary<MechanicalSummaryDTO, MechanicalWarrantyViewFieldErrorState>,
             bankApplicationSummary: BankApplicationSummaryDTO) => ({
                 personalDataFieldSummary,
                 vehicleDataFieldSummary,
                 creditDataFieldSummary,
                 insuranceDataFieldSummary,
                 mechanicalFieldSummary,
                 bankApplicationSummary,
                 type: CHECK_PREVIEW_QUOTE_SUBMENU_ACTION.name,
             })
};

export const CHECK_PREVIEW_INSURANCE_SUBMENU_ACTION: Action = {
    name: 'CHECK_PREVIEW_INSURANCE_SUBMENU_ACTION',
    action: (personalDataFieldSummary: FieldSummary<PersonalSummaryDTO, PersonalDataViewFieldErrorState>,
             homeDataFieldSummary: FieldSummary<HomeSummaryDTO, HomeDataViewFieldErrorState>,
             vehicleDataFieldSummary: FieldSummary<CRVehicleSummaryDTO, VehicleDataViewFieldErrorStateCR>,
             creditDataFieldSummary: FieldSummary<CRCreditConditionSummaryDTO, CreditConditionViewFieldErrorStateCR>,
             insuranceDataFieldSummary: FieldSummary<CRInsuranceSummaryDTO, InsuranceViewFieldErrorStateCR>) => ({
                 personalDataFieldSummary,
                 homeDataFieldSummary,
                 vehicleDataFieldSummary,
                 creditDataFieldSummary,
                 insuranceDataFieldSummary,
                 type: CHECK_PREVIEW_INSURANCE_SUBMENU_ACTION.name,
             })
};

export const CHECK_PREVIEW_GPS_SUBMENU_ACTION: Action = {
    name: 'CHECK_PREVIEW_GPS_SUBMENU_ACTION',
    action: (personalDataFieldSummary: FieldSummary<PersonalSummaryDTO, PersonalDataViewFieldErrorState>,
             homeDataFieldSummary: FieldSummary<HomeSummaryDTO, HomeDataViewFieldErrorState>,
             vehicleDataFieldSummary: FieldSummary<CRVehicleSummaryDTO, VehicleDataViewFieldErrorStateCR>,
             gpsDataFieldSummary: FieldSummary<GpsSummaryDTO, GpsViewFieldErrorState>) => ({
                 personalDataFieldSummary,
                 homeDataFieldSummary,
                 vehicleDataFieldSummary,
                 gpsDataFieldSummary,
                 type: CHECK_PREVIEW_GPS_SUBMENU_ACTION.name,
             })
};

export const CHECK_PREVIEW_BANK_ACCOUNT_SUBMENU_ACTION: Action = {
    name: 'CHECK_PREVIEW_BANK_ACCOUNT_SUBMENU_ACTION',
    action: (
        bankAccountDataFieldSummary: FieldSummary<BankAccountSummaryDTO, BankAccountInformationViewFieldErrorState>,
        insuranceDataFieldSummary: FieldSummary<CRInsuranceSummaryDTO, InsuranceViewFieldErrorStateCR>,
        mechanicalFieldSummary: FieldSummary<MechanicalSummaryDTO, MechanicalWarrantyViewFieldErrorState>,
        bankApplicationSummary: BankApplicationSummaryDTO,
        vehicleDataFieldSummary: FieldSummary<CRVehicleSummaryDTO, VehicleDataViewFieldErrorStateCR>,
    ) => ({
        bankAccountDataFieldSummary,
        insuranceDataFieldSummary,
        mechanicalFieldSummary,
        bankApplicationSummary,
        vehicleDataFieldSummary,
        type: CHECK_PREVIEW_BANK_ACCOUNT_SUBMENU_ACTION.name,
    })
};

export const ON_CHANGE_BANK_ACCOUNT_DATA_ACTION: Action = {
    name: 'ON_CHANGE_BANK_ACCOUNT_DATA_ACTION',
    action: () => ({
        type: ON_CHANGE_BANK_ACCOUNT_DATA_ACTION.name,
    })
};

export const ON_CHANGE_PERSONAL_DATA: Action = {
    name: 'ON_CHANGE_PERSONAL_DATA',
    action: () => ({
        type: ON_CHANGE_PERSONAL_DATA.name,
    })
};

export const ON_CHANGE_PERSONAL_SUCCESS_DATA: Action = {
    name: 'ON_CHANGE_PERSONAL_SUCCESS_DATA',
    action: (personalDataFieldSummary: FieldSummary<PersonalSummaryDTO, PersonalDataViewFieldErrorState>) => ({
        personalDataFieldSummary,
        type: ON_CHANGE_PERSONAL_SUCCESS_DATA.name,
    })
};

export const ON_CHANGE_HOME_DATA: Action = {
    name: 'ON_CHANGE_HOME_DATA',
    action: () => ({
        type: ON_CHANGE_HOME_DATA.name,
    })
};

export const ON_CHANGE_HOME_SUCCESS_DATA: Action = {
    name: 'ON_CHANGE_HOME_SUCCESS_DATA',
    action: (homeDataFieldSummary: FieldSummary<HomeSummaryDTO, HomeDataViewFieldErrorState>) => ({
        homeDataFieldSummary,
        type: ON_CHANGE_HOME_SUCCESS_DATA.name,
    })
};

export const ON_CHANGE_WORK_DATA: Action = {
    name: 'ON_CHANGE_WORK_DATA',
    action: () => ({
        type: ON_CHANGE_WORK_DATA.name,
    })
};

export const ON_CHANGE_WORK_SUCCESS_DATA: Action = {
    name: 'ON_CHANGE_WORK_SUCCESS_DATA',
    action: (workDataFieldSummary: FieldSummary<WorkSummaryDTO, WorkDataViewFieldErrorState>) => ({
        workDataFieldSummary,
        type: ON_CHANGE_WORK_SUCCESS_DATA.name,
    })
};

export const ON_CHANGE_REFERENCES_DATA: Action = {
    name: 'ON_CHANGE_REFERENCES_DATA',
    action: () => ({
        type: ON_CHANGE_REFERENCES_DATA.name,
    })
};

export const ON_CHANGE_REFERENCES_SUCCESS_DATA: Action = {
    name: 'ON_CHANGE_REFERENCES_SUCCESS_DATA',
    action: (referencesDataFieldSummary: FieldSummary<ReferenceSummaryDTO[], ReferenceViewFieldErrorState>) => ({
        referencesDataFieldSummary,
        type: ON_CHANGE_REFERENCES_SUCCESS_DATA.name,
    })
};

export const ON_CHANGE_VEHICLE_DATA: Action = {
    name: 'ON_CHANGE_VEHICLE_DATA',
    action: () => ({
        type: ON_CHANGE_VEHICLE_DATA.name,
    })
};

export const ON_CHANGE_VEHICLE_SUCCESS_DATA: Action = {
    name: 'ON_CHANGE_VEHICLE_SUCCESS_DATA',
    action: (vehicleDataFieldSummary: FieldSummary<CRVehicleSummaryDTO, VehicleDataViewFieldErrorStateCR>) => ({
        vehicleDataFieldSummary,
        type: ON_CHANGE_VEHICLE_SUCCESS_DATA.name,
    })
};

export const ON_CHANGE_CREDIT_CONDITION_DATA: Action = {
    name: 'ON_CHANGE_CREDIT_CONDITION_DATA',
    action: () => ({
        type: ON_CHANGE_CREDIT_CONDITION_DATA.name,
    })
};

export const ON_CHANGE_CREDIT_CONDITION_SUCCESS_DATA: Action = {
    name: 'ON_CHANGE_CREDIT_CONDITION_SUCCESS_DATA',
    action: (creditDataFieldSummary: FieldSummary<CRCreditConditionSummaryDTO,
    CreditConditionViewFieldErrorStateCR>) => ({
        creditDataFieldSummary,
        type: ON_CHANGE_CREDIT_CONDITION_SUCCESS_DATA.name,
    })
};

export const ON_CHANGE_INSURANCE_DATA: Action = {
    name: 'ON_CHANGE_INSURANCE_DATA',
    action: () => ({
        type: ON_CHANGE_INSURANCE_DATA.name,
    })
};

export const ON_CHANGE_INSURANCE_SUCCESS_DATA: Action = {
    name: 'ON_CHANGE_INSURANCE_SUCCESS_DATA',
    action: (insuranceDataFieldSummary: FieldSummary<CRInsuranceSummaryDTO, InsuranceViewFieldErrorStateCR>) => ({
        insuranceDataFieldSummary,
        type: ON_CHANGE_INSURANCE_SUCCESS_DATA.name,
    })
};

export const ON_CHANGE_MECHANICAL_DATA: Action = {
    name: 'ON_CHANGE_MECHANICAL_DATA',
    action: () => ({
        type: ON_CHANGE_MECHANICAL_DATA.name,
    })
};

export const ON_CHANGE_MECHANICAL_SUCCESS_DATA: Action = {
    name: 'ON_CHANGE_MECHANICAL_SUCCESS_DATA',
    action: (mechanicalFieldSummary: FieldSummary<MechanicalSummaryDTO, MechanicalWarrantyViewFieldErrorState>) => ({
        mechanicalFieldSummary,
        type: ON_CHANGE_MECHANICAL_SUCCESS_DATA.name,
    })
};

export const ON_CHANGE_GPS_DATA: Action = {
    name: 'ON_CHANGE_GPS_DATA',
    action: () => ({
        type: ON_CHANGE_GPS_DATA.name,
    })
};

export const ON_CHANGE_GPS_SUCCESS_DATA: Action = {
    name: 'ON_CHANGE_GPS_SUCCESS_DATA',
    action: (gpsDataFieldSummary: FieldSummary<GpsSummaryDTO, GpsViewFieldErrorState>) => ({
        gpsDataFieldSummary,
        type: ON_CHANGE_GPS_SUCCESS_DATA.name,
    })
};

export const ON_CHANGE_BANK_ACCOUNT_SUCCESS_DATA: Action = {
    name: 'ON_CHANGE_BANK_ACCOUNT_SUCCESS_DATA',
    action: (
        bankAccountDataFieldSummary: FieldSummary<BankAccountSummaryDTO, BankAccountInformationViewFieldErrorState>,
        insuranceDataFieldSummary: FieldSummary<CRInsuranceSummaryDTO, InsuranceViewFieldErrorStateCR>,
        mechanicalFieldSummary: FieldSummary<MechanicalSummaryDTO, MechanicalWarrantyViewFieldErrorState>,
        bankApplicationSummary: BankApplicationSummaryDTO
    ) => ({
        bankAccountDataFieldSummary,
        insuranceDataFieldSummary,
        mechanicalFieldSummary,
        bankApplicationSummary,
        type: ON_CHANGE_BANK_ACCOUNT_SUCCESS_DATA.name,
    })
};

export const ON_CHANGE_CLOSING_BANK_DATA: Action = {
    name: 'ON_CHANGE_CLOSING_BANK_DATA',
    action: () => ({
        type: ON_CHANGE_CLOSING_BANK_DATA.name,
    })
};

export const ON_CHANGE_APPROVAL_CONDITIONS_DATA: Action = {
    name: 'ON_CHANGE_APPROVAL_CONDITIONS_DATA',
    action: () => ({
        type: ON_CHANGE_APPROVAL_CONDITIONS_DATA.name,
    })
};

export const CHECK_PREVIEW_DEPOSIT_LETTER_SUBMENU_ACTION: Action = {
    name: 'CHECK_PREVIEW_DEPOSIT_LETTER_SUBMENU_ACTION',
    action: (
        personalDataFieldSummary: FieldSummary<PersonalSummaryDTO, PersonalDataViewFieldErrorState>,
        bankAccountDataFieldSummary: FieldSummary<BankAccountSummaryDTO, BankAccountInformationViewFieldErrorState>,
        closingBankFieldSummary: FieldSummary<ClosingBankSummaryDTO, ClosingBankViewFieldErrorState>
    ) => ({
        personalDataFieldSummary,
        bankAccountDataFieldSummary,
        closingBankFieldSummary,
        type: CHECK_PREVIEW_DEPOSIT_LETTER_SUBMENU_ACTION.name,
    })
};
